'use client';
import { useState } from 'react';
import clsx from 'clsx';
import offsetBlockClass from '@/utils/offsetBlockClass';
/**
 * Product tabs that are used in multiple different contexts: The bundle pdp,
 * normal pdps, within modals for cross sells and so on.
 */
export default function ProductTabs({
  block,
  modalIndex,
  position,
  renderContext
}) {
  const [activeTab, setActiveTab] = useState(0);
  // Check if it's a product description block, return null if not
  if (!block || !block.product_description) {
    return null;
  }
  const { tab_settings, _metadata, show_offset_block_selector } =
    block.product_description;

  const toggleTab = (index) => {
    if (index !== activeTab) {
      setActiveTab(index);
    }
  };

  return (
    <section
      id={`${_metadata.uid}_${position ?? modalIndex}`}
      className={clsx(
        offsetBlockClass(
          renderContext?.includes('modal') ? false : show_offset_block_selector,
          'text-default not-last:mb-8'
        ),
        {
          'px-2 pt-2 pb-4': renderContext === 'bundle-inventory-modal'
        },
        { 'pb-6 lg:pb-8': renderContext === 'cross-sell-modal' }
      )}
    >
      {tab_settings.length > 1 && (
        <div>
          <div className="flex-end flex flex-nowrap text-xl">
            {tab_settings.map((item, index) => (
              <button
                key={index}
                className={`sh12 product-tabs-choice ${activeTab === index ? 'active cursor-default text-white' : ''}`}
                onClick={() => toggleTab(index)}
              >
                {getTabTitle(item)}
              </button>
            ))}
          </div>
          <div
            className={clsx(
              'relative bottom-px border-b border-white',
              renderContext === 'bundle-inventory-modal' ? 'mb-4' : 'mb-6'
            )}
          ></div>
        </div>
      )}
      <div>
        {tab_settings.map((tab, index) => {
          const title = getTabTitle(tab).toLowerCase();
          return (
            <div
              key={index}
              className={`body-s product-description-tab ${activeTab === index ? 'active cursor-default' : ''}`}
              id={
                modalIndex !== undefined
                  ? `product-${title}-modal-${modalIndex}`
                  : `product-${title}-main`
              }
            >
              <div
                dangerouslySetInnerHTML={{ __html: tab.copy }}
                className="text-white"
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}

/**
 * Retrieves the title from a tab object, which can be 'title' or 'tab_title'.
 * It's tab_title when it comes from bundles and title when it comes from products.
 */
function getTabTitle(tab) {
  return tab.title ?? tab.tab_title;
}
